import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES } from './salesData';
export function OfferSection() {
  return <section id="comprar" className="bg-sand py-12 sm:py-16" data-id="element-175" data-mp="8mn50etwilza">
      <div className="mx-auto max-w-2xl px-5" data-id="element-176" data-mp="ddvh5imm8lg5">
        <div className="rounded-3xl border border-stone bg-ivory p-5 text-center shadow-[0_30px_70px_-50px_rgba(10,26,51,0.6)] sm:p-9" data-id="element-177" data-mp="dfq04rebu3hl">
          <h2 className="font-display text-[1.2rem] font-bold uppercase leading-tight text-charcoal sm:text-[1.7rem]" data-id="element-178" data-mp="metj7vdhuiw3">
            Todo lo que te llevás hoy
          </h2>

          <div className="mt-4 rounded-2xl bg-charcoal px-5 py-4 text-ivory" data-id="element-179" data-mp="repsoa4yn2j1">
            <p className="font-display text-lg font-bold uppercase leading-tight" data-id="element-180" data-mp="wbof06idu56o">
              Coach Digital PRO
            </p>
            <p className="mt-1 font-sans text-[0.78rem] font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-181" data-mp="2t7m9yepgr1bl">
              Mega Pack 6 en 1
            </p>
            <p className="mt-1.5 font-sans text-[0.78rem] font-semibold uppercase tracking-[0.14em] text-ivory/70" data-id="element-182" data-mp="12oa9kycxqdkt">
              + 5 bonos de regalo
            </p>
          </div>

          <ul className="mx-auto mt-5 grid max-w-md gap-1.5 text-left sm:grid-cols-2" data-id="element-183" data-mp="swxii8yynrfu">
            {OFFER_INCLUDES.map(item => <li key={item} className="flex items-start gap-2" data-id="element-184" data-mp="oxyecql1zypg">
                <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-185" data-mp="1lmmfmb8jv7c6" />
                <span className="font-sans text-[0.82rem] leading-snug text-charcoal/80" data-id="element-186" data-mp="1gn1im6cxx923">
                  {item}
                </span>
              </li>)}
          </ul>

          <PriceBlock className="mt-6" size="lg" data-id="element-187" data-mp="17mv6ooww4h51" />

          <div className="mt-5 flex justify-center" data-id="element-188" data-mp="17mbqbcmw20t4">
            <CTAButton label="QUIERO ACCEDER A COACH DIGITAL PRO" className="w-full max-w-[26rem] px-4" data-id="element-189" data-mp="172h3dxtwbat" />
          </div>

          <p className="mt-2.5 font-sans text-[0.75rem] text-charcoal/65" data-id="element-190" data-mp="3sewzz5457v61">
            Acceso inmediato después de tu compra.
          </p>
          <p className="mt-1 font-sans text-[0.72rem] text-charcoal/55" data-id="element-191" data-mp="2nyd5payh0xa">
            Pago seguro · Garantía 7 días
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-t border-stone pt-4 font-sans text-[0.7rem] text-charcoal/60" data-id="element-192" data-mp="3ksruzu79hjvp">
            <span className="inline-flex items-center gap-1.5" data-id="element-193" data-mp="3b2zyguflqgol">
              <LockIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-194" data-mp="3b1f5vacul7td" /> Pago seguro
            </span>
            <span aria-hidden className="text-charcoal/25" data-id="element-195" data-mp="3fw1ghbb3uwce">
              ·
            </span>
            <span data-id="element-196" data-mp="31394quyv85pk">Mercado Pago</span>
            <span aria-hidden className="text-charcoal/25" data-id="element-197" data-mp="363vq260i4mzb">
              ·
            </span>
            <span data-id="element-198" data-mp="2s444nk7no4ba">Tarjetas de crédito</span>
          </div>
        </div>
      </div>
    </section>;
}